import { Route, Routes } from "react-router-dom";
import Orders from "./Orders";

export default function OrdersRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Orders />} />
    </Routes>
  );
}
